import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { ofType } from "@ngrx/effects";
import { ActionsSubject, Store } from "@ngrx/store";
import { filter, Observable, Subject, takeUntil } from "rxjs";
import { selectDetectLanguageLoading } from "../../inbox/store/visitors.selectors";
import { TranslationLanguages, Visitor } from "src/app/models";
import * as VisitorActions from '../../inbox/store/visitors.actions';
import { currentUser } from "../auth";
import { AppState } from "../core.state";
import { InlineSVGDirective } from "../inline-svg/inline-svg.directive";

@Component({
    selector: 'charla-live-translation',
    templateUrl: './live-translation.component.html',
    styleUrls: ['./live-translation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ReactiveFormsModule, NgSelectModule, InlineSVGDirective]
})
export class LiveTranslationComponent{

    @Input() visitor: Visitor; 
    @Input() popover!: NgbPopover;
    @Output() on = new EventEmitter<{ language_agent: string, language_visitor: string }>();
    @Output() off = new EventEmitter<void>();

    unsubscribe$ = new Subject();

	translations_languages = TranslationLanguages;
	form_translate: UntypedFormGroup;
	is_loading_detect_language$: Observable<boolean>;
    

    constructor(
        private store: Store<AppState>,
        private fb: UntypedFormBuilder,
        private actions$: ActionsSubject
    ){


        // Create the auto translation form
        this.form_translate = this.fb.group({
            language_agent: "",
            language_visitor: "en",
        });

    
        this.store.select(currentUser).pipe(
            filter( u => u != null),
            takeUntil(this.unsubscribe$)
        ).subscribe( u => {
            this.form_translate.get('language_agent').patchValue(u.live_translation_language);
        });
		
        this.actions$.pipe(
            ofType(VisitorActions.DetectLanguageSuccess),
            takeUntil(this.unsubscribe$)
        ).subscribe(data => { 
            if (data.language) this.form_translate.get('language_visitor').patchValue(data.language);
        });

        this.is_loading_detect_language$ = this.store.select(selectDetectLanguageLoading);


    }

    ngOnChanges(changes: SimpleChanges) {

        if ( changes['visitor'] && changes['visitor'].currentValue ) {
            let v = changes['visitor'].currentValue as Visitor;
            if (v.language_visitor) {
                this.form_translate.get('language_visitor').patchValue(v.language_visitor);
            }

            if(v.language_agent){
                this.form_translate.get('language_agent').patchValue(v.language_agent);
            }
        }

    }

    apply_translation(){

        this.on.emit({
            language_agent: this.form_translate.get('language_agent').value,
            language_visitor: this.form_translate.get('language_visitor').value
        });

	}

	stop_translation(){

        this.off.emit();

	}

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

}